type CourseFormDataForValidation = {
  expectedParticipants?: number;
  maxParticipants?: number;
};

export const validateCourseFormData = (
  formData: CourseFormDataForValidation
): Record<string, string> => {
  const validationErrors: Record<string, string> = {};

  if (formData.maxParticipants === undefined || formData.maxParticipants === null) {
    validationErrors.maxParticipants = 'courseForm.validation.maxParticipantsRequired';
  } else if (formData.maxParticipants > 1000) {
    validationErrors.maxParticipants = 'courseForm.validation.maxParticipantsTooHigh';
  }

  if (
    formData.expectedParticipants !== undefined &&
    formData.expectedParticipants !== null &&
    formData.maxParticipants !== undefined &&
    formData.maxParticipants !== null &&
    formData.expectedParticipants > formData.maxParticipants
  ) {
    validationErrors.expectedParticipants = 'courseForm.validation.expectedParticipantsExceedsMax';
  }

  return validationErrors;
};
